// Global course compare functions
const courseCompareStorageKey = 'course_compare';

window.addCourseToCompare = function(courseCode) {
  var storedCourses = getStoredCompareCoursesArray();
  if(storedCourses.length > 0) {
    if(!storedCourses.includes(courseCode)) {
      storedCourses.push(courseCode);
    }
  } else {
    var storedCourses = [courseCode];
  }
  window.setLocalStorageValue(courseCompareStorageKey, JSON.stringify(storedCourses));
}

window.removeCourseFromCompare = function(courseCode) {
  var storedCourses = getStoredCompareCoursesArray();
  if(storedCourses.length > 0) {
    for(var i=0; i<storedCourses.length; i++) {
      if(storedCourses[i] == courseCode) {
        storedCourses.splice(i, 1);
        break;
      }
    }
    window.setLocalStorageValue(courseCompareStorageKey, JSON.stringify(storedCourses));
  }
}

window.getStoredCompareCoursesArray = function() {
  var storedCoursesString = window.getLocalStorageValue(courseCompareStorageKey);
  if(storedCoursesString) {
    return JSON.parse(storedCoursesString);
  }
  return [];
}

window.getLocalStorageValue = function(key) {
  return localStorage.getItem(key);
}

window.setLocalStorageValue = function(key, value) {
  localStorage.setItem(key, value);
}

// My Save Courses page logic
export default (() => {

  class MySavedCourses {
    constructor(savedCoursesListSelector, compareCoursesSelector) {
      this.$savedCoursesListContainer = $(savedCoursesListSelector);
      this.$compareCoursesContainer = $(compareCoursesSelector);
      this.localStoredCourses = [];
      this.loadedCourseData = [];
      this.comparedCourseCodes = [];
    }

    init() {
      var self = this;

      if(!self.$savedCoursesListContainer.length || !self.$compareCoursesContainer.length) {
        return;
      }

      self.getCourseCodesFromUrlParams();
      self.getSavedCourseData();
    }

    getSavedCourseData() {
      var self = this;

      self.localStoredCourses = getStoredCompareCoursesArray();

      if(self.localStoredCourses.length > 0  || self.comparedCourseCodes.length > 0) {
        $.ajax({
          url: '/my-saved-courses/get',
          cache: false,
          dataType: 'json',
          method: 'post',
          data: { 'courseCodes': self.combineArrays(self.localStoredCourses, self.comparedCourseCodes) }, // Combine courses from local storage and URL params (for sharing URLs)
          success: function(response) {
            if(response.status == true) {
              self.loadedCourseData = response.data;
              self.populateSavedCourseList();
              self.renderCompareTable();
            } else {
              self.handleAjaxError();
            }
          },
          error: function(response) {
            self.handleAjaxError();
          }
        });
      } else {
        self.$savedCoursesListContainer.html('<p>You currently don\'t have any courses saved. Please select "Save and compare" on a course page for at least 2 courses.</p>\
            <p class="lead">Browse our courses <a href="/study/all-courses">here</a></p>');
      }

    }

    populateSavedCourseList() {
      var self = this;

      self.$savedCoursesListContainer.empty();

      for(var i=0; i<self.loadedCourseData.length; i++) {
        var courseListTitleElement = $('<a />')
          .attr('href', self.loadedCourseData[i].url)
          .attr('target', '_blank')
          .text(self.loadedCourseData[i].course_code + ' - ' + self.loadedCourseData[i].title);

        var courseListCompareInput = $('<input />')
          .addClass('custom-control-input')
          .attr('type', 'checkbox')
          .attr('data-course-compare-input', '1')
          .attr('id', 'input_compare_' + self.loadedCourseData[i].course_code)
          .val(self.loadedCourseData[i].course_code);

        var courseListRemoveLink = $('<a />')
          .attr('href', '#')
          .attr('data-remove-compare-course', self.loadedCourseData[i].course_code)
          .text('Remove from list');

        courseListCompareInput.on('change', function() {
          self.handleCompareInputClick($(this));
        });

        courseListRemoveLink.on('click', function(e) {
          e.preventDefault();
          self.handleRemoveCourseClick($(this));
        });

        var courseListTitleColumn = $('<div />').addClass('course-list-column-title');
        courseListTitleColumn.append(courseListTitleElement);

        var courseListInputColumn = $('<div />').addClass('course-list-column-input').append('<div class="custom-control custom-checkbox">');
        courseListInputColumn.find('.custom-control').append(courseListCompareInput).append('<label class="custom-control-label" for="input_compare_' + self.loadedCourseData[i].course_code + '">Compare</label>');

        var courseListRemoveColumn = $('<div />').addClass('course-list-column-remove');
        courseListRemoveColumn.append(courseListRemoveLink);

        var courseListRow = $('<div />').addClass('course-list-row')
          .append(courseListTitleColumn)
          .append(courseListInputColumn)
          .append(courseListRemoveColumn);

        self.$savedCoursesListContainer.append(courseListRow);
      }

      // Disabled for now, breaks on page load
      // // Auto select first 2 courses if not selected
      // if(self.comparedCourseCodes.length < 2) {
      //   for(var i=self.comparedCourseCodes.length; i<2; i++) {
      //     self.comparedCourseCodes.push($('[data-course-compare-input]').eq(i).val());
      //   }
      // }

      // Pre check checkboxes from URL params
      for(var i=0; i<self.comparedCourseCodes.length; i++) {
        $('[data-course-compare-input][value="' + self.comparedCourseCodes[i] + '"]').prop('checked', true);
      }
      self.handleInputMaxSelection();
      self.updateUrlParams();
    }

    renderCompareTable() {
      var self = this;

      self.$compareCoursesContainer.html('<div class="course-compare-header">\
        <h4>Course comparison:</h4>\
        <div class="text-right"><a href="#" class="btn btn-secondary" data-toggle="modal" data-target="#modal-share">Share</a></div>\
      </div>');

      if(self.localStoredCourses.length < 1 && self.comparedCourseCodes.length < 1) {
        self.$compareCoursesContainer.append('<p>You currently don\'t have any courses saved. Please select "Save and compare" on a course page for at least 2 courses.</p>\
          <p class="lead">Browse our courses <a href="/study/all-courses">here</a></p>');
        return;
      } else if(self.localStoredCourses.length == 1 && self.comparedCourseCodes.length < 1) {
        self.$compareCoursesContainer.append('<p>You currently only have 1 course saved. Please select "Save and compare" on a course page for at least 2 courses.</p>\
          <p class="lead">Browse our courses <a href="/study/all-courses">here</a></p>');
        return;
      } else if(self.comparedCourseCodes.length <= 1) {
        self.$compareCoursesContainer.append('<p>Please select "Save and compare" on a course page for at least 2 courses.</p>\
          <p class="lead">Browse our courses <a href="/study/all-courses">here</a></p>');
        return;
      } else if(self.comparedCourseCodes.length < 2) {
        self.$compareCoursesContainer.append('<p>Please select at least 2 courses to compare above.</p>');
        return;
      }

      var tableColWidth = (self.comparedCourseCodes.length > 1) ? self.comparedCourseCodes.length : 2; // Force a placeholder column when only 1 selected
      self.$compareCoursesContainer.append('<div class="scroll-indicator col-count-' + tableColWidth + '"><div class="scroll-text">Swipe or scroll horizontally to see more</div></div>')

      var $table = $('<div />').addClass('sticky-table');
      var $courseTitlesRowInner = $('<div />').addClass('sticky-table-row-inner col-count-' + tableColWidth);
      var $courseLengthRowInner = $('<div />').addClass('sticky-table-row-inner col-count-' + tableColWidth);
      var $courseContactHoursRowInner = $('<div />').addClass('sticky-table-row-inner col-count-' + tableColWidth);
      var $courseCostRowInner = $('<div />').addClass('sticky-table-row-inner col-count-' + tableColWidth);
      var $courseFreeTafeRowInner = $('<div />').addClass('sticky-table-row-inner col-count-' + tableColWidth);
      var $courseCampusesRowInner = $('<div />').addClass('sticky-table-row-inner col-count-' + tableColWidth);
      var $courseDeliveryModeRowInner = $('<div />').addClass('sticky-table-row-inner col-count-' + tableColWidth);
      var $courseViewRowInner = $('<div />').addClass('sticky-table-row-inner col-count-' + tableColWidth);

      var courseLengthCheck = false;
      var courseContactHoursCheck = false;
      var courseCostCheck = false;
      var courseFreeTafeCheck = false;
      var courseCampusesCheck = false;
      var courseDeliveryModeCheck = false;

      for(var i=0; i<self.comparedCourseCodes.length; i++) {
        var course = self.getCourseDataByCourseCode(self.comparedCourseCodes[i]);
        if(!course) {
          continue;
        }

        // Course title
        var $col = $('<div />').addClass('sticky-table-col sticky-table-heading').html('<a href="' + course.url + '">' + course.course_code + ' - ' + course.title + '</a>');
        $courseTitlesRowInner.append($col);

        // Contact length
        var $col = $('<div />').addClass('sticky-table-col');
        if(course.hasOwnProperty('length')) {
          courseLengthCheck = true
          if(course.length.hasOwnProperty('full_time')) {
            $col.append(course.length.full_time + '<br />');
          }
          if(course.length.hasOwnProperty('part_time')) {
            $col.append(course.length.part_time);
          }
        } else {
          $col.append(' - ');
        }
        $courseLengthRowInner.append($col);

        // Course hours
        var $col = $('<div />').addClass('sticky-table-col');
        if(course.hasOwnProperty('contact_hours')) {
          courseContactHoursCheck = true;
          if(course.contact_hours.hasOwnProperty('full_time')) {
            $col.append(course.contact_hours.full_time + '<br />');
          }
          if(course.contact_hours.hasOwnProperty('part_time')) {
            $col.append(course.contact_hours.part_time);
          }
        } else {
          $col.append(' - ');
        }
        $courseContactHoursRowInner.append($col);

        // Course cost
        var $col = $('<div />').addClass('sticky-table-col d-flex justify-content-center');
        var $innerWrap = $('<div />').addClass('text-left');
        if(course.hasOwnProperty('cost')) {
          courseCostCheck = true;
          if(course.cost.hasOwnProperty('fees')) {
            for(var j=0; j<course.cost.fees.length; j++) {
              $innerWrap.append('<div class="d-flex justify-content-between">\
                <div class="mb-2 mr-2 w-75">' + course.cost.fees[j][0] + ':</div>\
                <div class="mb-2"><strong>' + course.cost.fees[j][1] + '</strong></div>\
              </div>');
            }
          }
          if(course.cost.hasOwnProperty('fee_help') && course.cost.fee_help == true) {
            $innerWrap.append('Fee help is available');
          }
        } else {
          $col.append(' - ');
        }
        $courseCostRowInner.append($col.append($innerWrap[0].outerHTML));

        // Free TAFE
        var $col = $('<div />').addClass('sticky-table-col');
        if(course.hasOwnProperty('free_tafe')) {
          courseFreeTafeCheck = true;
          $col.append(course.free_tafe == true ? 'Yes' : 'No');
        } else {
          $col.append('No');
        }
        $courseFreeTafeRowInner.append($col);

        // Campuses
        var $col = $('<div />').addClass('sticky-table-col');
        if(course.hasOwnProperty('campuses')) {
          courseCampusesCheck = true;
          for(var j=0; j<course.campuses.length; j++) {
            $col.append(course.campuses[j] + '<br />');
          }
        } else {
          $col.append(' - ');
        }
        $courseCampusesRowInner.append($col);

        // Delivery Mode
        var $col = $('<div />').addClass('sticky-table-col');
        if(course.hasOwnProperty('delivery_mode')) {
          courseDeliveryModeCheck = true;
          for(var j=0; j<course.delivery_mode.length; j++) {
            $col.append(course.delivery_mode[j] + '<br />');
          }
        } else {
          $col.append(' - ');
        }
        $courseDeliveryModeRowInner.append($col);

        // View button
        var $col = $('<div />').addClass('sticky-table-col');
        if(course.hasOwnProperty('url')) {
          $col.append('<a href="' + course.url + '" class="btn btn-primary">View Course Page</a>');
        }
        $courseViewRowInner.append($col);
      }

      // Put in placeholder column if only 1 selected
      if(self.comparedCourseCodes.length == 1) {
        $courseTitlesRowInner.append('<div class="sticky-table-col sticky-table-heading placeholder-col">Add another course from your list above</div>');
        $courseLengthRowInner.append('<div class="sticky-table-col"> - </div>');
        $courseContactHoursRowInner.append('<div class="sticky-table-col"> - </div>');
        $courseCostRowInner.append('<div class="sticky-table-col"> - </div>');
        $courseFreeTafeRowInner.append('<div class="sticky-table-col"> - </div>');
        $courseCampusesRowInner.append('<div class="sticky-table-col"> - </div>');
        $courseDeliveryModeRowInner.append('<div class="sticky-table-col"> - </div>');
        $courseDeliveryViewRowInner.append('<div class="sticky-table-col"></div>');
      }

      $table.append('<div class="sticky-table-row-static-heading"><div class="sticky-table-heading-container">' + $courseTitlesRowInner[0].outerHTML + '</div></div>');
      if(courseLengthCheck) {
        $table.append('<div class="sticky-table-row-static"><div class="sticky-table-subheading">Course length</div></div>');
        $table.append('<div class="sticky-table-row">' + $courseLengthRowInner[0].outerHTML + '</div>');
      }
      if(courseContactHoursCheck) {
        $table.append('<div class="sticky-table-row-static"><div class="sticky-table-subheading">Contact hours</div></div>');
        $table.append('<div class="sticky-table-row">' + $courseContactHoursRowInner[0].outerHTML + '</div>');
      }
      if(courseCostCheck) {
        $table.append('<div class="sticky-table-row-static"><div class="sticky-table-subheading">Cost</div></div>');
        $table.append('<div class="sticky-table-row">' + $courseCostRowInner[0].outerHTML + '</div>');
      }
      if(courseFreeTafeCheck) {
        $table.append('<div class="sticky-table-row-static"><div class="sticky-table-subheading">Free TAFE available?</div></div>');
        $table.append('<div class="sticky-table-row">' + $courseFreeTafeRowInner[0].outerHTML + '</div>');
      }
      if(courseCampusesCheck) {
        $table.append('<div class="sticky-table-row-static"><div class="sticky-table-subheading">Campuses</div></div>');
        $table.append('<div class="sticky-table-row">' + $courseCampusesRowInner[0].outerHTML + '</div>');
      }
      if(courseDeliveryModeCheck) {
        $table.append('<div class="sticky-table-row-static"><div class="sticky-table-subheading">Delivery mode</div></div>');
        $table.append('<div class="sticky-table-row">' + $courseDeliveryModeRowInner[0].outerHTML + '</div>');
      }
      $table.append('<div class="sticky-table-row">' + $courseViewRowInner[0].outerHTML + '</div>');

      // Horizontal scroll sticky row
      self.handleStickyHeadersX($table);

      self.$compareCoursesContainer.append($table);

      // Vertical scroll sticky row
      self.handleStickyHeadersY($table);
    }

    getCourseDataByCourseCode(courseCode) {
      var self = this;

      for(var i=0; i<self.loadedCourseData.length; i++) {
        if(self.loadedCourseData[i].course_code == courseCode) {
          return self.loadedCourseData[i];
        }
      }
      return false;
    }

    handleCompareInputClick($input) {
      var self = this;

      self.resetSelectedCourses();
      self.handleInputMaxSelection();
      self.updateUrlParams();
      self.renderCompareTable();
    }

    handleRemoveCourseClick($el) {
      var self = this;

      $el.closest('.course-list-row').remove();
      removeCourseFromCompare($el.attr('data-remove-compare-course'));
      self.localStoredCourses = getStoredCompareCoursesArray();

      self.resetSelectedCourses();
      self.updateUrlParams();
      self.renderCompareTable();
    }

    resetSelectedCourses() {
      var self = this;

      self.comparedCourseCodes = [];
      $('[data-course-compare-input]').each(function() {
        if($(this).is(':checked')) {
          self.comparedCourseCodes.push($(this).val());
        }
      });
    }

    handleInputMaxSelection() {
      var self = this;

      if($('[data-course-compare-input]:checked').length >= 3) {
        $('[data-course-compare-input]').not(':checked').attr('disabled', 'disabled');
      } else {
        $('[data-course-compare-input]').removeAttr('disabled');
      }
    }

    handleStickyHeadersY($stickTable) {
      var $window = $(window);
      var $stickyHeading = $stickTable.find('.sticky-table-row-static-heading').eq(0);
      var $stickyHeadingRow = $stickyHeading.find('.sticky-table-heading-container');
      var $lastEl = $stickTable.find('.sticky-table-row').last().prev();

      $window.scroll(function() {
        var mobileMenuOffset = $('.main-navigation-mobile').is(":visible") ? $('.main-navigation-mobile').height() : 0;
        var headingHeight = $stickyHeading ? $stickyHeading.height() : 0;
        var windowYPos = $window.scrollTop() + mobileMenuOffset;
        var containerYPos = Math.ceil($stickyHeading.offset().top);
        var yPos = Math.ceil($stickyHeadingRow.offset().top);

        if((
            windowYPos > yPos || // Scoll down past heading
            windowYPos > containerYPos && windowYPos < yPos // Scroll up within stickTable
          ) && (
            windowYPos < Math.ceil($lastEl.offset().top) + $lastEl.height() - $stickyHeading.height() // Prevent scroll past lastEl
          ))
        {
          $stickyHeadingRow.css('top', (parseInt(windowYPos) - parseInt(containerYPos)) + 'px').css('position', 'absolute');
          $stickyHeading.css('height', headingHeight + 'px');
        } else if(windowYPos <= containerYPos) { // Before reached header
          $stickyHeadingRow.css('top', '').css('position', '');
          $stickyHeading.css('height', '');
        } else if(windowYPos >= Math.ceil($lastEl.offset().top) + $lastEl.height() - $stickyHeading.height()) { // After lastEl
          $stickyHeadingRow.css('top', (Math.ceil($lastEl.offset().top) + $lastEl.height() - parseInt(containerYPos) - $stickyHeading.height() + 'px'));
          $stickyHeading.css('height', headingHeight + 'px');
        }

        // Sticky rows
        $stickTable.find('.sticky-table-row-static').each(function() {
          var windowYPos = $window.scrollTop() + mobileMenuOffset + headingHeight;
          var $stickyRow = $(this).find('.sticky-table-subheading');
          var containerYPos = Math.ceil($(this).offset().top);
          var yPos = Math.ceil($stickyRow.offset().top);
          var $nextEl = $(this).next('.sticky-table-row');

          if((
              windowYPos > yPos || // Scoll down past subheader
              windowYPos > containerYPos && windowYPos < yPos // Scroll up within nextEl
            ) && (
              windowYPos < Math.ceil($nextEl.offset().top) + $nextEl.height() - $(this).height() // Prevent scroll past nextEl
            ))
          {
            $stickyRow.css('top', (parseInt(windowYPos) - parseInt(containerYPos)) + 'px');
          } else if(windowYPos <= containerYPos) { // Before reached header
            $stickyRow.css('top', '');
          } else if(windowYPos >= Math.ceil($nextEl.offset().top) + $nextEl.height() - $(this).height()) { // After nextEl
            $stickyRow.css('top', (Math.ceil($nextEl.offset().top) + $nextEl.height() - parseInt(containerYPos) - $(this).height() + 'px'));
          }
        });
      });
    }

    handleStickyHeadersX($table) {
      $table.scroll(function() {
        $table.find('.sticky-table-subheading').css('left', $table.scrollLeft());
      });
    }

    updateUrlParams() {
      var self = this;

      if($('[data-course-compare-input]:checked').length < 1) {
        window.history.pushState({'my-saved-courses': 'course-codes'}, document.title, window.location.href.split('?')[0]);
        return;
      }

      var selectedCourses = [];

      $('[data-course-compare-input]:checked').each(function() {
        selectedCourses.push($(this).val());
      });

      var paramsString = '?course-codes=' + selectedCourses.join(',');
      window.history.pushState({'my-saved-courses': 'course-codes'}, document.title, window.location.href.split('?')[0] + paramsString);
    }

    handleAjaxError() {
      var self = this;

      self.$savedCoursesListContainer.html('<div class="course-list-row">\
          <div class="col-12 col-md-8">\
              There was an error loading your saved courses\
          </div>\
      </div>');
    }

    getCourseCodesFromUrlParams() {
      var self = this;

      var q = window.location.search.substring(1);
      var params = self.parseQueryString(q);
      if(!params.hasOwnProperty('course-codes')) {
        return;
      }
      if(params['course-codes'].split(',')[0] != 'undefined') {
        self.comparedCourseCodes = params['course-codes'].split(',').slice(0, 3); // Max 3 course via URL
      }
    }

    combineArrays(arr1, arr2) {
      for(var i=0; i<arr2.length; i++) {
        if(!arr1.includes(arr2[i])) {
          arr1.push(arr2[i]);
        }
      }
      return arr1;
    }

    parseQueryString(query) {
      var vars = query.split("&");
      var query_string = {};
      for(var i=0; i<vars.length; i++) {
        var pair = vars[i].split("=");
        var key = decodeURIComponent(pair[0]);
        var value = decodeURIComponent(pair[1]);
        // If first entry with this name
        if(typeof query_string[key] === "undefined") {
          query_string[key] = decodeURIComponent(value);
        // If second entry with this name
        } else if(typeof query_string[key] === "string") {
          var arr = [query_string[key], decodeURIComponent(value)];
          query_string[key] = arr;
        // If third or later entry with this name
        } else {
          query_string[key].push(decodeURIComponent(value));
        }
      }
      return query_string;
    }

  }

  const mySavedCourses = new MySavedCourses('[data-saved-courses-list]', '[data-compare-courses-table]');
  mySavedCourses.init();

})();
